module.exports = __webpack_public_path__ + "img/w38.e0641785.svg";